// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"374":"4e099551","457":"7b0b68e6","766":"0305d60b","866":"73b76213","982":"ed26706c"}[chunkId] + ".chunk.js";
};